import React, {ReactElement} from "react";
import {Tooltip} from "antd";
import {TooltipPlacement} from "antd/lib/tooltip";
import {formatString} from "@data-force/app";
import {TranslateFunction} from "react-localize-redux";
import "./JobTitle.scss";

interface Props {
    translate: TranslateFunction
    phaseName: string
    title: string
    tooltipRequired?: boolean
    tooltipPlacement?: TooltipPlacement
}

const translatePath: string = "components.common.JobTitle";

const JobTitle: React.FC<Props> = ({
    phaseName, title, tooltipRequired, tooltipPlacement, translate,
}: Props): ReactElement<HTMLSpanElement> => (
    <Tooltip
        title={tooltipRequired ? formatString(translate(`${translatePath}.tooltipFormat.text`) as string, phaseName, title) : null}
        placement={tooltipPlacement}
    >
        <span className="df-job-title">
            <strong>{phaseName}</strong>
            {formatString(translate(`${translatePath}.titleFormat.text`) as string, title)}
        </span>
    </Tooltip>

);

JobTitle.defaultProps = {
    tooltipRequired: false,
    tooltipPlacement: "top",
};

export default JobTitle;
